import { COLORS } from '@shared/config/colors/colors';
import { styled } from 'goober';

export const ModalFooter = styled('div')`
    display: flex;
    width: 100%;
    justify-content: flex-end;
`;

export const ModalBody = styled('div')`
    display: flex;
    gap: 20px;
    flex-direction: column;
`;

export const ListOfSteps = styled('ul')`
    display: flex;
    gap: 12px;
    flex-direction: column;

    > li {
        position: relative;
        list-style: none;
        padding-left: 40px;

        &:not(:last-child) {
            padding-bottom: 12px;
        }
    }
`;

export const StepItem = styled('li')`
    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 8px;
        height: 8px;
        border-radius: 12px;
        background: ${COLORS.neutral_00};
        border: 6px solid ${COLORS.bright_blue};
    }

    &:not(:last-child):after {
        content: '';
        position: absolute;
        top: 24px;
        left: 9px;
        width: 2px;
        height: calc(100% - 25px);
        border-radius: 12px;
        background: ${COLORS.neutral_30};
    }
`;

export const FilesList = styled('div')`
    display: flex;
    flex-direction: column;
    gap: 12px;
`;
